import { combineReducers } from 'redux'
import { addVeranstaltungPanelReducer, veranstaltungenReducer } from './veranstaltungen/reducers'
import { addTeilnahmeReducer, teilnahmeMeldungenReducer, erfassteTeilnahmenReducer, qrReaderReducer, beschriftungenReducer,
	meldeversuchReducer } from './punkteMeldung/reducer'
import {FETCH_VERANSTALTUNG_REQUEST, FETCH_VERANSTALTUNG_REQUEST_SUCCESS,
	FETCH_VERANSTALTUNG_REQUEST_FAILURE,
	FETCH_PUNKTEMELDUNGEN_REQUEST,
	FETCH_PUNKTEMELDUNGEN_REQUEST_SUCCESS,
	FETCH_PUNKTEMELDUNGEN_REQUEST_FAILURE} from './veranstaltungen/actions'
import { appNavigationReducer } from './appNavigation/reducer';
import { confirmDialogReducer } from './confirmDialog/reducer';
import { alertsReducer } from './alerts/reducer';

const punkteMeldungReducer = combineReducers({
	teilnahmeMeldungen : 	teilnahmeMeldungenReducer,
	addTeilnahme : 			addTeilnahmeReducer,
	qrReader :				qrReaderReducer,
	erfassteTeilnahmen : 	erfassteTeilnahmenReducer,
	beschriftungen :		beschriftungenReducer,
	meldeversuch :			meldeversuchReducer
});

const fetchCounterReducer = (state = 0, action) => {
	switch (action.type){
		case FETCH_VERANSTALTUNG_REQUEST:
		case FETCH_PUNKTEMELDUNGEN_REQUEST:
			return ++state;
		case FETCH_VERANSTALTUNG_REQUEST_SUCCESS:
		case FETCH_VERANSTALTUNG_REQUEST_FAILURE:
		case FETCH_PUNKTEMELDUNGEN_REQUEST_SUCCESS:
		case FETCH_PUNKTEMELDUNGEN_REQUEST_FAILURE:
				return --state;
			default:
				return state;
			}

		};

const rootReducer = combineReducers({
	alerts : alertsReducer ,
	appNavigation : appNavigationReducer,
	fetchCounter : fetchCounterReducer,
	addVeranstaltungPanel : addVeranstaltungPanelReducer,
	veranstaltungen : veranstaltungenReducer,
	confirmDialog: confirmDialogReducer,
	punkteMeldung : punkteMeldungReducer
});

export default rootReducer
